import {LocationIdAndNameObject} from "@/models/location/LocationIdAndNameObject";
import {ActivityInfo} from "@/models/activity/ActivityInfo";

export class ActivitySetInfo{
    activitySetId:number = -1;
    id:number = -1;
    name:string = "";
    activities:Array<ActivityInfo> = [];
    activitySetLocationInfo:Array<LocationIdAndNameObject> = []
}